var _linearGradient, _radialGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelaxTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    viewBox: "0 0 510 510",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 69.57,
    x2: 86.139,
    y1: 91.43,
    y2: 107.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdec7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#b0e995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    stopColor: "#87e4bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835,
    stopColor: "#6ee1d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e0db"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 197.865,
    cy: 183.135,
    r: 319.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.377,
    stopColor: "#1accfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#22c3fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#2fb5f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.937,
    stopColor: "#41a1f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "g",
    x1: 346.115,
    x2: 627.696,
    y1: 267.01,
    y2: 287.997,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "h",
    x1: 60.019,
    x2: 289.132,
    y1: 296.109,
    y2: 373.063,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "i",
    x1: 184.733,
    x2: 216.113,
    y1: 187.868,
    y2: 198.408,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "j",
    x1: 324.904,
    x2: 355.461,
    y1: 237.597,
    y2: 247.86,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "k",
    x1: 160.109,
    x2: 179.469,
    y1: 239.158,
    y2: 245.661,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "l",
    x1: 233.663,
    x2: 276.621,
    y1: 166.716,
    y2: 181.145,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "m",
    x1: 288.482,
    x2: 331.116,
    y1: 186.17,
    y2: 200.49,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "n",
    x1: 15.646,
    x2: 176.553,
    y1: 387.417,
    y2: 387.417,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "o",
    x1: 333.518,
    x2: 494.355,
    y1: 387.43,
    y2: 387.43,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#f12817",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#dd2820",
    stopOpacity: 0.607
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#d",
    id: "p",
    x1: 126,
    x2: 197.985,
    y1: 358.919,
    y2: 358.919,
    gradientUnits: "userSpaceOnUse"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#d",
    id: "q",
    x1: 390.741,
    x2: 545.408,
    y1: 360.045,
    y2: 459.378,
    gradientUnits: "userSpaceOnUse"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m123.73 86.336-65.246 56.027-16.468-19.178c-5.014-5.839-4.345-14.637 1.494-19.651l44.1-37.869c5.839-5.014 14.637-4.345 19.651 1.494z",
    "data-original": "url(#e)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M255.001 41.239C114.15 41.239.549 154.377.002 295.227c-.2 51.545 14.893 99.552 41.003 139.743 42.906 66.047 145.873 27.691 134.717-50.276-4.472-31.252-6.979-61.725-7.05-87.335-.133-47.693 38.168-87.196 85.86-87.449 47.894-.254 86.8 38.494 86.8 86.329 0 25.712-2.49 56.441-6.984 87.985-11.149 78.242 91.608 117.01 134.658 50.732C494.937 395.031 510 347.394 510 296.239c0-140.832-114.167-254.999-254.999-255",
    "data-original": "url(#f)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M376.44 71.959c48.872 46.458 79.342 112.091 79.342 184.844 0 51.155-15.063 98.792-40.996 138.717-18.258 28.11-47.255 37.318-73.749 32.639 23.191 46.038 94.075 58.975 127.966 6.796C494.937 395.031 510 347.394 510 296.239c0-96.866-54.011-181.116-133.56-224.28",
    "data-original": "url(#g)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M219.552 192.505c-47.692.227-85.993 35.654-85.86 78.426.071 22.968 2.578 50.296 7.05 78.324 9.444 59.192-62.895 92.918-111.349 65.941a255 255 0 0 0 11.612 19.773c42.906 66.047 145.872 27.691 134.716-50.275-4.472-31.252-6.979-61.725-7.05-87.335-.133-47.693 38.168-87.196 85.86-87.449a86.3 86.3 0 0 1 24.286 3.352c-15.521-12.959-36.358-20.866-59.265-20.757",
    "data-original": "url(#h)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M207.921 176.361a97.1 97.1 0 0 0-25.491 20.489 8.5 8.5 0 0 0 .725 11.999 8.47 8.47 0 0 0 5.242 2.13 8.48 8.48 0 0 0 6.756-2.854 80.2 80.2 0 0 1 21.039-16.91 8.5 8.5 0 0 0 3.291-11.561 8.5 8.5 0 0 0-11.562-3.293",
    "data-original": "url(#i)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M344.934 224.966a8.5 8.5 0 0 0-15.773 6.342 79.3 79.3 0 0 1 5.661 26.361 8.5 8.5 0 1 0 16.986-.702 96.2 96.2 0 0 0-6.874-32.001",
    "data-original": "url(#j)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M176.241 219.973a8.5 8.5 0 0 0-11.071 4.682c-4.121 10.164-6.469 20.922-6.977 31.974a8.5 8.5 0 0 0 16.982.78c.419-9.122 2.353-17.992 5.749-26.365a8.5 8.5 0 0 0-4.683-11.071",
    "data-original": "url(#k)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M271.505 165.583c-10.74-1.844-21.964-1.874-32.698-.065a8.5 8.5 0 0 0-6.97 9.794 8.5 8.5 0 0 0 7.984 7.081 8.5 8.5 0 0 0 1.81-.111c8.854-1.491 18.134-1.467 26.996.057a8.5 8.5 0 0 0 9.817-6.938 8.5 8.5 0 0 0-6.939-9.818",
    "data-original": "url(#l)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M327.782 197.114a96.9 96.9 0 0 0-25.42-20.593c-4.096-2.298-9.275-.841-11.573 3.253s-.842 9.275 3.253 11.573a80 80 0 0 1 20.971 16.99 8.48 8.48 0 0 0 5.995 2.88 8.47 8.47 0 0 0 6-2.107 8.5 8.5 0 0 0 .774-11.996",
    "data-original": "url(#m)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M15.646 384.356a254 254 0 0 0 25.359 50.614c5.87 9.035 12.868 16.104 20.539 21.397-.009-.459-.035-.914-.035-1.376 0-39.206 31.783-70.989 70.989-70.989 16.622 0 31.897 5.728 43.994 15.298a80.4 80.4 0 0 0-.771-14.606c-3.028-21.16-5.151-41.957-6.231-61.135a136.6 136.6 0 0 0-36.992-5.093c-49.547.001-92.928 26.396-116.852 65.89",
    "data-original": "url(#n)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M377.502 318.467a136.6 136.6 0 0 0-36.994 5.093c-1.072 19.037-3.169 39.665-6.162 60.664a81 81 0 0 0-.753 15.009c12.084-9.529 27.326-15.231 43.909-15.231 39.206 0 70.989 31.783 70.989 70.989 0 .47-.026.933-.035 1.401 7.667-5.301 14.668-12.381 20.549-21.436a254 254 0 0 0 25.35-50.599c-23.925-39.495-67.306-65.89-116.853-65.89",
    "data-original": "url(#o)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M169.49 323.56a136.5 136.5 0 0 0-32.888-5.021 629 629 0 0 0 4.14 30.717c2.068 12.965.213 24.708-4.455 34.859 15.149.799 29.034 6.35 40.205 15.187a80.4 80.4 0 0 0-.771-14.606c-3.028-21.161-5.151-41.958-6.231-61.136",
    "data-original": "url(#p)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M494.355 384.357a137.2 137.2 0 0 0-50.93-48.927 253.9 253.9 0 0 1-28.214 59.426c19.986 12.559 33.28 34.789 33.28 60.135 0 .062.122.485.329 1.16 7.526-5.273 14.395-12.283 20.184-21.195a254 254 0 0 0 25.351-50.599",
    "data-original": "url(#q)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaxTravel);
export default __webpack_public_path__ + "static/media/relax-travel.131b39997e4ea0dc4222076da9dd0a45.svg";
export { ForwardRef as ReactComponent };